module.exports = __webpack_public_path__ + "static/media/whisky_video.4dd90842.jpg";